import React from "react";
import { AppMode } from "@lifeat/shared/system/AppModeTypes";

export type AppModeContextType = {
    appMode: AppMode;
    setAppMode: (appMode: AppMode) => void;
};

export const AppModeContext = React.createContext<AppModeContextType | undefined>(undefined);
export const useAppModeContext = () => {
    const context = React.useContext(AppModeContext);
    if (context == null) {
        throw new Error("Missing AppModeContext");
    }
    return context;
};
